// extracted by mini-css-extract-plugin
export default {"field":"AttachmentEditStep_field__2a6k7","buttons":"AttachmentEditStep_buttons__50lUK"};